import React, { useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {
  deletePersona,
  fetchPersonas,
} from "../../../redux/actions/personasActions";
import classes from "../Brand/Brand.module.css";
import { AuthContext } from "../../../context/auth-context";
import Table, {
  StyledTableCell,
  StyledTableRow,
} from "../../../Component/UI/Table/Table";
import MUIIconButton from "./../../../Component/UI/MUIIconButton/MUIIconButton";
import Spinner from "./../../../Component/Spinner/Spinner";

const TABLE_HEADERS = [
  { id: "Personas", name: "Personas", sorting: true },
  { id: "details", name: "Details", sorting: false },
  { id: "actions", name: "Actions", sorting: false },
];

const Personas = ({
  setPersonasName,
  setpersonasDetails,
  setModalOpen,
  setUpdateModalOpen,
  setSelectPersonasID,
}) => {
  const dispatch = useDispatch();
  const personas = useSelector((state) => state.personas);
  console.log("personasData",personas)
  const { user } = useContext(AuthContext);
  const customerId = user?.customer_id || 0;

  useEffect(() => {
    // if (personas?.data && personas?.data.length === 0) {
    if (customerId) {
      dispatch(fetchPersonas(customerId));
    }
  }, [dispatch]);

  const personasData = personas.data.data;

  const sortedPersonasData = personasData
    ? [...personasData].sort((a, b) => {
        if (a.persona.name === "General Persona") return -1;
        if (b.persona.name === "General Persona") return 1;
        return 0;
      })
    : [];

  const renderRow = (item) => (
    <StyledTableRow key={item.id}>
      <StyledTableCell component="th" scope="row" style={{ width: 450 }}>
        <div className={classes.brand_product}>
          <span>{item.persona.name}</span>
        </div>
      </StyledTableCell>
      <StyledTableCell align="left" style={{ width: 450 }}>
        {item.persona.description}
      </StyledTableCell>

      <StyledTableCell align="left">
        <div>
          {item.persona.name !== "General Persona" && (
            <>
              <MUIIconButton
                style={{ color: "#028101" }}
                className={classes.action_btn}
                tooltip="Edit"
                onClick={() => {
                  setPersonasName(item.persona.name);
                  setpersonasDetails(item.persona.description);
                  setModalOpen(true);
                  setUpdateModalOpen(true);
                  setSelectPersonasID(item);
                }}
              >
                <EditOutlinedIcon />
              </MUIIconButton>
              <MUIIconButton
                style={{ color: "#da1a04" }}
                tooltip="Delete"
                className={classes.action_btn}
                onClick={() => handleDeletePersona(item.id)}
              >
                <DeleteOutlineIcon />
              </MUIIconButton>
            </>
          )}
        </div>
      </StyledTableCell>
    </StyledTableRow>
  );
  const handleDeletePersona = (personaId) => {
    dispatch(deletePersona(customerId, personaId)).then(() => {
      dispatch(fetchPersonas(customerId));
    });
  };
  return (
    <>
      {personas.loading && <Spinner />}
      {!personas.loading && sortedPersonasData && sortedPersonasData?.length > 0 && (
        <Table headers={TABLE_HEADERS} data={sortedPersonasData} render={renderRow} />
      )}
    </>
  );
};

export default Personas;